// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3YvFO","header":"ClearentDisclaimer_header__MjdqY","inner":"ClearentDisclaimer_inner__R5FgE"};